module.exports = __webpack_public_path__ + "static/media/new-york-bank.66c72cb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/new-york-bank.svg
// module id = 96
// module chunks = 0